module.exports = __webpack_public_path__ + "static/media/itc.85298645.svg";